import Default from 'components/layouts/Guest/Default';
import SignUp from 'components/templates/SignUp/SignUp';

const App = () => (
  <Default>
    <SignUp />
  </Default>
);

export default App;
